import { graphql } from "react-relay";
import { InviteButton } from "@components/invite-button";

export const fragments = {
  org: graphql`
    fragment InviteCard_org on Org {
      ...InviteButton_org
    }
  `,
};
